"use strict";
const template = require("./visualizerTemplate");
function makeVisualizerPage(options = {}) {
  const {
    cdn = "https://www.lactame.com/visualizer",
    fallbackVersion = "latest",
    queryType = "fragment",
    loadversion = "none",
    config = "",
    viewURL = "",
    scripts = []
  } = options;
  let configTemplate = "";
  if (typeof config === "string") {
    configTemplate = `'${config}'`;
  } else if (typeof config === "object" && typeof config !== null) {
    configTemplate = JSON.stringify(config);
  }
  validateQueryType(queryType);
  validateLoadVersion(loadversion);
  const scriptsStr = scripts.reduce(function(value, script) {
    if (script.url) {
      return value + `<script src="${script.url}"><\/script>
`;
    } else if (script.content) {
      return value + `<script>${script.content}<\/script>
`;
    } else {
      throw new Error("script must have url or content");
    }
  }, "");
  return template.replace("{{ cdn }}", cdn).replace("{{ fallbackVersion }}", fallbackVersion).replace("{{ scripts }}", scriptsStr).replace("{{ queryType }}", queryType).replace("{{ loadversion }}", loadversion).replace("{{ viewURL }}", viewURL).replace("{{ config }}", configTemplate);
}
module.exports = makeVisualizerPage;
const validLoadversion = ["none", "exact", "latest-major"];
function validateLoadVersion(loadversion) {
  if (!validLoadversion.includes(loadversion)) {
    throw new Error(
      `Invalid "loadversion" parameter: ${loadversion}. Allowed values: ${validLoadversion.join(", ")}`
    );
  }
}
const validQueryType = ["fragment", "query"];
function validateQueryType(queryType) {
  if (!validQueryType.includes(queryType)) {
    throw new Error(
      `Invalid "queryType" parameter: ${queryType}, allowed values: ${validQueryType.join(", ")}`
    );
  }
}
